import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import {
    Box,
    Button,
    Card,
    Typography
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PostAddIcon from '@mui/icons-material/PostAdd';
import VideocamIcon from '@mui/icons-material/Videocam';

import KonsolLogo from '../components/logo/KonsolLogo';
import CreateProjectModal from '../components/modal/CreateProjectModal';
import CardListItem from '../components/listitem/CardListItem';

export default function ProjectSelectionView(props) {
    const { projects, onProjectSwitch, dataLoaded } = props

    const navigate = useNavigate()
    const { logout, user } = useAuth0();

    const [breadCrumbs, setBreadCrumbs] = useState(['Select A Project'])
    const [isNewProject, setIsNewProject] = useState(false)

    const handleSwitch = (project) => {
        onProjectSwitch(project)
        navigate('/about')
    }

    const handleLogout = () => {
        logout({ logoutParams: {returnTo: process.env.REACT_APP_AUTH0_LOGOUT_URL}})
    }

    return (
        <React.Fragment>
            <Box
                height={'100%'}
                width={'100%'}
                display={'flex'}
                position={'absolute'}
                top={0}
                right={0}
                bottom={0}
                left={0}
                justifyContent={'center'}
                alignItems={'center'}
            >
                <Card
                    sx={{
                        background: 'rgba(48, 89, 69, 0.2)',
                        borderRadius: '16px',
                        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.5)',
                        backdropFilter: 'blur(4.5px)',
                        transitionProperty: 'box-shadow',
                        transitionDuration: '1s',
                        width: 400,
                        height: 540
                    }}
                >
                    <Box 
                        display={'flex'}
                        height={'100%'}
                        flexDirection={'column'}
                    >
                        <Box 
                            display={'flex'}
                            justifyContent={'center'}
                            pt={5}
                        >
                            <KonsolLogo
                                isLoading={dataLoaded ? false : true}
                                width={300}
                                height={76}
                            />
                        </Box>
                        <Box
                            display='flex'
                            justifyContent='center'
                            py={2}
                        >
                            <Typography
                                component="span"
                                variant="h6"
                                color="rgba(177,236, 175, 0.9)"
                            >
                                {`Welcome ${user?.name ?? ''}`}
                            </Typography>
                        </Box>
                        {dataLoaded &&
                        <Box>
                            <Box
                                height='270px'
                                px={4}
                                py={2}
                            >
                                <Box
                                    sx={{
                                        pl: 2.5
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                            color: 'white'
                                        }}
                                    >
                                        {breadCrumbs.join(' > ')}
                                    </Typography>
                                </Box>
                                <Box
                                    height='100%'
                                    border='1px solid rgb(125, 125, 125)'
                                    borderRadius={5}
                                    sx={{
                                        boxSizing: 'border-box',
                                        py: 2
                                    }}
                                >
                                    <Box
                                        height='100%'
                                        overflow='auto'
                                    >
                                        {isNewProject
                                        ?
                                            <CreateProjectModal
                                                handleSwitch={handleSwitch}
                                                projects={projects}
                                                setBreadCrumbs={setBreadCrumbs}
                                            />
                                        :
                                            projects.map(project => ({
                                                avatar: project?.project_image || 'K',
                                                primary: project?.project_name || project?.project_db,
                                                onClick: () => handleSwitch(project),
                                                secondary: (
                                                    [
                                                        // Items to form the secondary text of the format:
                                                        // {text: '', icon: Component }
                                                    ].map((item, index) => (
                                                        <Box
                                                            key={index}
                                                            display='inline-flex'
                                                            alignItems='center'
                                                        >
                                                            {index > 0 &&
                                                                <Typography
                                                                    component={'span'}
                                                                    sx={{
                                                                        margin: '0 4px',
                                                                        lineHeight: 0
                                                                    }}
                                                                >
                                                                    •
                                                                </Typography>
                                                            }
                                                            {item?.icon &&
                                                                <Box
                                                                    pr={0.5}
                                                                    display='flex'
                                                                    alignItems='center'
                                                                >
                                                                    <item.icon sx={{ fontSize: '11px' }}/>
                                                                </Box>
                                                            }
                                                            <Box>
                                                                {item?.text}
                                                            </Box>
                                                        </Box>
                                                    ))
                                                )
                                            }))
                                            // .concat({
                                            //     primary: 'Create a new project',
                                            //     avatar: (
                                            //         <Box>
                                            //             <PostAddIcon />
                                            //         </Box>
                                            //     ),
                                            //     action: <ArrowForwardIcon style={{ fill: 'rgba(255, 255, 255, 1)' }} />,
                                            //     onClick: () => setIsNewProject(true)
                                            // })
                                            .map((item, index) => (
                                                <Box
                                                    px={1}
                                                    py={0.5}
                                                    key={index}
                                                >
                                                    <CardListItem
                                                        avatar={item?.avatar}
                                                        item={item}
                                                        primary={item?.primary}
                                                        secondary={item?.secondary}
                                                    />
                                                </Box>
                                            ))
                                        }
                                    </Box>
                                </Box>
                            </Box>
                            <Box
                                px={4}
                            >
                                <Button
                                    sx={{
                                        width: '100%',
                                        color: 'rgb(200, 200, 200)',
                                        border: '1px solid rgb(150, 150, 150)',
                                        // backgroundColor: isNewProject ? 'transparent' : 'rgba(100, 0, 0, 0.3)',
                                        borderRadius: 5,
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            color: 'rgb(255, 255, 255)',
                                            backgroundColor: isNewProject ? 'rgba(0, 0, 0, 0.3)' : 'rgba(200, 50, 50, 0.3)'
                                            // border: '1px solid rgb(255, 255, 255)'
                                        }
                                    }}
                                    onClick={
                                        isNewProject
                                        ?
                                        () => {
                                            setIsNewProject(false)
                                            setBreadCrumbs(['Select A Project'])
                                        }
                                        :
                                        () => handleLogout()
                                    }
                                >
                                    {isNewProject ? 'Cancel' : 'Logout'}
                                </Button>
                            </Box>
                        </Box>
                        }
                    </Box>
                </Card>
            </Box>
        </React.Fragment>
    )
}